import { defineStore } from 'pinia'
import { USER } from '@/utils/constants'
import { ILoginData } from '@/api/account'

export const useUserStore = defineStore(USER, {
  state: () => {
    return {
      user: {} as ILoginData
    }
  },
  actions: {
    setUser(u: ILoginData) {
      this.user = u
    }
  },
  persist: {
    enabled: true,
    strategies: [{
      key: 'user',
      storage: localStorage,
    }]
  }
})